<template>
  <footer>
    <div class="container footer_main">
      <div class="d-flex flex-column flex-lg-row flex-md-row">
        <div class="col-6 d-flex flex-lg-row flex-md-row flex-column mt-4 mt-lg-0 mt-md-0">
          <div class="copyright">
            © 2026 Prepaid Surprise
          </div>
          <a href="https://www.odido.nl/voorwaarden" class="footer_link mt-4 mt-lg-0 mt-md-0">Voorwaarden</a>
        </div>
        <div
          class="col-6 d-flex flex-row justify-content-start justify-content-md-end justify-content-lg-end mt-4 mt-lg-0 mt-md-0">
          <a href="https://facebook.com/OdidoNederland " class="social">
            <img src="./../assets/img/footer/fb_icon.svg" alt="">
          </a>
          <a href="https://x.com/OdidoNederland" class="social">
            <img src="./../assets/img/footer/x_icon.svg" alt="">
          </a>
          <a href="https://community.odido.nl" class="social">
            <img src="./../assets/img/millen_images/telekom_icon.svg" alt="">
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue